import React from 'react';
import { Navigation } from 'lucide-react';

const GoogleMaps = ({ address = "Hietasaarenkatu 18, 65100 Vaasa, Finland" }) => {
  // Encode address for Google Maps URL
  const encodedAddress = encodeURIComponent(address);
  const mapSrc = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;

  return (
    <div className="w-full">
      {/* Map Container */}
      <div className="w-full h-96 rounded-xl overflow-hidden shadow-lg border-4 border-amber-400/30 mb-4">
        <iframe
          title="Sunsari Restaurant Location"
          src={mapSrc}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      
      {/* Get Directions Button */}
      <div className="flex justify-center">
        <a
          href={directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
        >
          <Navigation className="w-5 h-5" />
          <span>Get Directions to Sunsari</span>
        </a>
      </div>
    </div>
  );
};

export default GoogleMaps;
